import { PermissionsEnum } from "@/auth/interfaces";
import { EstadosProcesoEnumChoice, ROUTER_PATHS, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchOrdenesCompras } from "@/shared/actions/erp"
import { GeneralTable, LoaderComponent } from "@/shared/components/ui";
import useTableColumnsRecepcionCompra from "@/shared/hooks/useTableColumnsRecepcionCompra"
import { OrdenesCompra } from "@/shared/interfaces/erp/compras/ordenes-compra.interface";
import { useRecepcionMercaderia } from "@/store/erp/recepcion-mercaderia/recepcion-mercaderia-store";
import { useUiStore } from "@/store/ui";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


export default function RecepcionCompraAbiertoPage() {
  useCheckPermissions(PermissionsEnum.api_view_ordencompra)

  const navigate = useNavigate()
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const isOpenModal = useRecepcionMercaderia(s => s.isOpenModal)
  const setIsOpenModal = useRecepcionMercaderia(s => s.setIsOpenModal)
  //

  useEffect(() => {
    if (!isOpenModal) return
    setConfirmDialogIsOpen(true)
    setConfirmDialog({
      isOpen: true,
      cancelTextBtn: 'NO',
      title: 'Imprimir o Descargar comprobante',
     
      subtitle: '¿Desea ir a imprimir o descargar \n el detalle de los productos ingresados?',
      confirmTextBtn: 'Si',
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm: () => {
        setConfirmDialogIsOpen(false)
        navigate(`${ROUTER_PATHS.compras.orden_compras_consulta_nav}`)
      }
    })
    setIsOpenModal(false)
  }, [isOpenModal])
  ///
  const { columnsGeneralRecepcion } = useTableColumnsRecepcionCompra()
  //hook
  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { columnFilters, filterObject, setColumnFilters } = useTableServerSideFiltering();
  const { pageIndex, pageSize } = pagination;
  //**fetch */
  const { data: dataOrdenCompra, isLoading: isLoading, isRefetching } = useFetchOrdenesCompras({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_orden_in: `${EstadosProcesoEnumChoice.ABIERTO},${EstadosProcesoEnumChoice.PARCIAL}`,
    //estado_orden: EstadosProcesoEnumChoice.ABIERTO,
    ...filterObject,
    filterByState: true
  })
  if (isLoading) return <LoaderComponent />
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GeneralTable<OrdenesCompra>
            columns={columnsGeneralRecepcion}
            data={dataOrdenCompra?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataOrdenCompra?.data?.count}
            // // actions
            actionsColumnSize={120}
            //
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            canDelete={false}
            positionActionsColumn='first'
            canEdit={false}
            enableColumnActions={true}
            enableEditing={false}
          />

        </Grid>

      </Grid>
    </>
  )
}